/**
 * Created by zhongzhengkai on 2016/12/26.
 */

import { doRequest } from "./tool/net";
import { getToken } from "./temp-cache";

export const getApiHost = () => {
  return __SERVER_HOST__;
};

export const getL2LHost = () => {
  if (process.env.NODE_ENV === "production") {
    return "https://cm-portal.porsche-cloudservice.com";
  }
  return "https://crm-portal.dev.porsche-preview.cn";
};

//mode属性用来决定是否允许跨域请求，以及哪些response属性可读。可选的mode属性值为same-origin，no-cors（默认）以及cors。
var mode = "cors";
var headers = {
  "Content-Type": "application/json",
  "Source-Type": "cm_portal"
};

const defaultSpec = { attachPrefix: true, hasReply: true, throwError: false };
//请求特征设定 reqSpec: {noPrefix:true, hasReply:true}
export const doGet = (path, cb, inputReqSpec) => {
  var token = getToken();
  if (
    (token == null || token == "") &&
    !path.includes("/account/sign-in") &&
    path.indexOf("/iam/v1/jwt") < 1
  ) {
    $vm.$router.push({ path: "/login" });
  }
  if (token) headers.token = token;
  var reqSpec = { ...defaultSpec, ...inputReqSpec };

  if (path.indexOf("?") > 0) {
    path = path + "&random=" + Math.random();
  } else {
    path = path + "?r=" + Math.random();
  }
  request(path, { method: "GET", mode, headers }, cb, reqSpec);
};

export const doPost = (path, toPost, cb, inputReqSpec) => {
  var token = getToken();
  if (
    (token == null || token == "") &&
    !path.includes("/account/sign-in") &&
    path.indexOf("/iam/v1/jwt") < 1
  ) {
    $vm.$router.push({ path: "/login" });
  }
  if (token) headers.token = token;
  var reqSpec = { ...defaultSpec, ...inputReqSpec };
  request(path, { method: "POST", body: toPost, mode, headers }, cb, reqSpec);
};

const requestReplyStatus = {};
const TIME_OUT = 38000;
var tokenExpireMessageCount = 0;

export const request = function request(
  path,
  options,
  cb,
  reqSpec = {
    attachPrefix: true,
    hasReply: true, //false 可能没结果
    json: true,
    throwError: false,
  }
) {
  var urlPrefix = getApiHost();
  if(path.indexOf('crm-portal/management')>0){
    urlPrefix = getL2LHost();
  }
  var fullPath;
  if (reqSpec.attachPrefix) fullPath = urlPrefix + path;
  else fullPath = path;
  var requestReply;
  var timerId = setTimeout(() => {
    if (!requestReply) {
      //alert('http request timeout!');
      console.log("http request timeout!");
    }
    requestReplyStatus[timerId] = "REQUEST_TIMEOUT";
  }, TIME_OUT);
  requestReplyStatus[timerId] = "REQUEST_START";

  callRequest(fullPath, options, reqSpec, (err, reply) => {
    console.log("------>>>>>> " + options.method, path);
    if (options.body != undefined) {
      console.log("------ body : " + options.body);
    }
    console.log("<<<<<<------ back : ", JSON.stringify(reply, null, 2));
    console.log("---------------------------------");
    console.log("");

    requestReply = reply;
    clearTimeout(timerId);

    if (requestReplyStatus[timerId] != "REQUEST_TIMEOUT") {
      requestReplyStatus[timerId] = "REQUEST_END";

      if (err) {
        if (err.message == "Failed to fetch") {
          //alert('当前服务器连接不可用，请稍后再试！');
          console.log("当前服务器连接不可用，请稍后再试！");
        } else {
          if (reqSpec.throwError) {
            if (cb) cb(requestReply, { code: -100, errorMessage: err.message });
            else console.log(requestReply);
          } else console.log(err.message);
        }
      } else {
        if (reqSpec.hasReply) {
          var { code, errorMessage } = requestReply;
          if (code != 0) {
            var errText = requestReply.errorMessage;
            if (reqSpec.throwError) {
              if (cb) {
                cb(requestReply, { code, errorMessage });
              } else {
                //alert(errText);
                console.log(errText);
              }
            } else {
              if (code == "2") {
                tokenExpireMessageCount++;
                if (tokenExpireMessageCount == 1) {
                  if (window.location.href.indexOf("/login") < 0) {
                    //alert('登录会话已超时，请退出重新登录！');
                    console.log("登录会话已超时，请退出重新登录！");
                    tokenExpireMessageCount = 0;
                    $vm.$router.push({ path: "/login" });
                  }
                }
              } else {
                //alert(errText);
                // console.log(errText);
                cb(requestReply, { code, errorMessage });
              }
            }
          } else {
            if (cb) {
              var data;
              if (requestReply.body && requestReply.body.data)
                data = requestReply.body.data;
              else if (requestReply.data) data = requestReply.data;
              //同时兼容我们的后端返回格式
              else data = requestReply;

              if (reqSpec.throwError) cb(data, { code, errorMessage });
              else cb(data);
            }
          }
        } else {
          console.log("%cwarning: path " + path + " no reply!", "color:red");
        }
      }
    } else {
      console.debug("REQUEST_TIMEOUT for path:" + path);
    }
  });
};

function callRequest(fullPath, options, reqSpec, reqCb) {
  try {
    doRequest(fullPath, options, reqSpec, reqCb);
  } catch (ex) {
    console.log(ex.message);
    //alert(ex.message);
  }
}

export function Toast(msg, duration, width) {
  duration = isNaN(duration) ? 3000 : duration;
  var m = document.createElement("div");
  m.innerHTML = msg;
  if (width == null || width == undefined) {
    width = 150;
  }
  m.style.cssText =
    "width:" +
    width +
    "px; background:#000; opacity:0.5; height:40px; color:#fff; line-height:40px; text-align:center; border-radius:5px; position:fixed; top:50%; left:50%;margin-left:-80px;margin-top:-20px; z-index:9999999999;padding:0 5px;";
  document.body.appendChild(m);
  setTimeout(function () {
    var d = 0.5;
    m.style.webkitTransition =
      "-webkit-transform " + d + "s ease-in, opacity " + d + "s ease-in";
    m.style.opacity = "0";
    setTimeout(function () {
      document.body.removeChild(m);
    }, d * 1000);
  }, duration);
}



// WEBPACK FOOTER //
// ./src/base/common-func.js